import authApi from 'resources/authApi';

export const cancelClaimGLN = (claimId: number) => () =>
  authApi.UserClaimGlnDelete(claimId);
